import {ErrorHandler, ErrorLoggingService, HttpError} from './http';
import {Dictionary} from '../common';

declare global {
    interface Window {
        captureException(err: any): void;
    }
}

export const loggingService: ErrorLoggingService = {
    logError(err: any): void {
        // sentry isn't configured in local environment
        // definition location : front/alerting/src/configuration.js
        if (window.captureException && typeof window.captureException === 'function') {
            window.captureException(err);
            return;
        }

        console.info('error occured', err);
    },
};

export class DefaultErrorHandler implements ErrorHandler {
    private static mustBeLogged(err: HttpError): boolean {
        return !!err.response && (err.response.status === 429 || err.response.status === 400);
    }

    private errorLoggingService: ErrorLoggingService;

    constructor(
        {errorLoggingService}: any = {
            errorLoggingService: loggingService,
        },
    ) {
        this.errorLoggingService = errorLoggingService;
    }

    handle(err: HttpError) {
        if (DefaultErrorHandler.mustBeLogged(err)) {
            this.logError(err);
        }
    }

    private logError(err: Dictionary<any>): void {
        this.errorLoggingService.logError(err);
    }
}
